/* Slow Knit Studio · the whole of the theme's JavaScript.
   Theme toggle, two scroll states, and the pattern language option.
   No carousels, no modals, no animation libraries, no dependencies. */
(function () {
  'use strict';

  var root = document.documentElement;
  var THEME_KEY = 'sks-theme';
  var LANG_KEY = 'sks-pattern-lang';

  function read(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      /* private mode, or storage is full. The page still works. */
    }
  }

  /* Theme · three states. "auto" removes the attribute and lets
     color-scheme: light dark follow the system. The same choice is applied
     inline in <head> before first paint; this only keeps the buttons in sync. */
  function applyTheme(mode) {
    if (mode === 'light' || mode === 'dark') {
      root.setAttribute('data-theme', mode);
    } else {
      root.removeAttribute('data-theme');
    }
    document.querySelectorAll('.toggle button').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.mode === mode));
    });
  }

  applyTheme(read(THEME_KEY) || 'auto');

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.toggle button');
    if (!button) return;
    applyTheme(button.dataset.mode);
    write(THEME_KEY, button.dataset.mode);
  });

  /* Scroll states · the header hairline and the docked buy pill.
     The header never hides and never changes height. The quick links need no
     scroll state: they live in the rail, so they are never in the way. */
  var header = document.querySelector('.hdr');
  var buy = document.querySelector('.buy');
  var pill = buy && buy.querySelector('[data-pill]');

  function onScroll() {
    if (header) {
      if (window.scrollY > 12) header.setAttribute('data-scrolled', '');
      else header.removeAttribute('data-scrolled');
    }
    /* Dock the pill once its place in the hero has scrolled off the top. The
       wrapper holds its height, so the page does not shift underneath it. */
    if (pill) {
      if (buy.getBoundingClientRect().bottom < 0) pill.setAttribute('data-docked', '');
      else pill.removeAttribute('data-docked');
    }
  }

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Pattern language · the product's one option.
     Each button names the content block it shows. Several languages can resolve
     to the same block, which is what happens when a language is published as a
     PDF but the page text for it is not written yet, so the button is
     identified by its own option value and the block by its key. */
  var pickers = document.querySelectorAll('.langs-pick');
  if (!pickers.length) return;

  var picks = document.querySelectorAll('.langs-pick button');
  var blocks = document.querySelectorAll('.pattern-lang');
  var live = document.getElementById('lang-live');
  var variantInput = document.querySelector('#product-form [name="id"]');
  var pillPrice = document.querySelector('[data-pill] .num');
  var pillVariant = document.querySelector('[data-pill] [data-pill-variant]');
  var langToggle = document.querySelector('[data-pill-lang]');
  var langPanel = document.getElementById('pill-langs');

  function closePanel(focusToggle) {
    if (!langPanel || langPanel.hidden) return;
    langPanel.hidden = true;
    if (langToggle) langToggle.setAttribute('aria-expanded', 'false');
    if (focusToggle && langToggle) langToggle.focus();
  }

  function setLang(button, announce) {
    var key = button.dataset.block;

    blocks.forEach(function (element) {
      element.hidden = element.dataset.block !== key;
    });

    /* Each block carries its own lang attribute, so there is nothing to set on
       the page. Putting the pattern's language on <main> would tell a screen
       reader that the Norwegian header and footer are English. */

    /* Two rows show the same languages, one in the hero and one in the pill,
       so the pressed state follows the option rather than the button that was
       clicked. Comparing identity would leave the other row showing nothing
       selected. */
    picks.forEach(function (other) {
      other.setAttribute('aria-pressed', String(other.dataset.option === button.dataset.option));
    });

    if (variantInput && button.dataset.variantId) {
      variantInput.value = button.dataset.variantId;
    }
    if (pillPrice && button.dataset.price) {
      pillPrice.textContent = button.dataset.price;
    }
    if (pillVariant) {
      pillVariant.textContent = button.dataset.option;
    }

    if (announce && live && live.dataset.template) {
      live.textContent = live.dataset.template.replace('%s', button.dataset.option);
    }
  }

  picks.forEach(function (button) {
    button.addEventListener('click', function () {
      setLang(button, true);
      write(LANG_KEY, button.dataset.option);
      closePanel(false);
    });
  });

  /* The pill's language segment. Esc closes it, a click outside closes it, and
     it closes itself once a language is chosen. */
  if (langToggle && langPanel) {
    langToggle.addEventListener('click', function () {
      var open = langPanel.hidden;
      langPanel.hidden = !open;
      langToggle.setAttribute('aria-expanded', String(open));
      if (open) {
        var first = langPanel.querySelector('button:not([disabled])');
        if (first) first.focus();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel(true);
    });

    document.addEventListener('click', function (event) {
      if (langPanel.hidden) return;
      if (langPanel.contains(event.target) || langToggle.contains(event.target)) return;
      closePanel(false);
    });
  }

  /* The server already rendered the language of the selected variant. Only
     override it when the visitor has a remembered choice this pattern is
     published in. */
  var remembered = read(LANG_KEY);
  if (remembered) {
    picks.forEach(function (button) {
      if (button.dataset.option === remembered && !button.disabled) {
        setLang(button, false);
      }
    });
  }
})();

/* Policy headings. Shopify renders these pages itself, so the display line
   cannot be built in Liquid the way every other page builds it. The first word
   is flipped to roman here instead. With scripts off the heading stays fully
   italic, which is the same line, just without the flip. */
(function () {
  var heading = document.querySelector('.shopify-policy__title h1');
  if (!heading || heading.querySelector('.roman')) return;

  var text = heading.textContent.trim();
  var space = text.indexOf(' ');
  if (space < 1) return;

  var roman = document.createElement('span');
  roman.className = 'roman';
  roman.textContent = text.slice(0, space);

  heading.textContent = '';
  heading.append(roman, ' ' + text.slice(space + 1));
  heading.classList.add('display');
})();
